/**
 * Отправка формы
 */

export default (function(win, doc) {
    /**
     *
     * @param {string} elem     - класс формы
     * @param {object} options  - дополнительные настройки
     * @return void
     */

    function Form(elem, options = {}) {

        /**
         * Что можно передать в options
         *
         * @param {string} url - адрес для ajax (обязательный)
         * @param {string} buttonClass - класс кнопки отправить
         * @param {string} errorTextClass - класс блока с сообщением об ошибке
         * @param {string} errorClass - класс элемента в котором есть ошибка
         *
         * @param {function} statusOk - Функция сработает при удачной отправке формы
         * @param {function} statusError - Функция сработает при не удачной отправке формы
         * @param {function} afterResponse - Функция сработает после отправки формы
         */

        // Если нет url для ajax или не указан класс элемента закрываем функцию
        if (!options.url && !elem) {
            return false;
        }

        // Стандартные имена классов
        let buttonClass = options.buttonClass ? options.buttonClass : 'send_button',
            errorTextClass = options.errorTextClass ? options.errorTextClass : 'js-Feedback_error-text',
            errorClass = options.errorClass ? options.errorClass : 'error';

        //
        let formsList = document.getElementsByClassName(elem),
            feedbackBtn = document.querySelectorAll(`.${buttonClass}`);

        // Ищем все формы
        if (formsList.length) {
            for (let i = 0; i < formsList.length; i++) {
                // Проверяем инициализирована ли форма, если да то пропускаем ее
                if (formsList[i].classList.contains('is-initialized')) {
                    continue;
                }

                let formSubmitFn = function() {
                    // При клике на кнопку блокируем ее до ответа с сервера
                    feedbackBtn.forEach( function(item) {
                        item.style.opacity = '.8';
                        item.style.cursor = 'not-allowed';
                        item.disabled = true;
                    });

                    let nameInput = this.parentElement.querySelector('input[name="name"]').value,
                        phoneInputValue = this.parentElement.querySelector('input[name="tel"]').value,
                        policy = this.parentElement.querySelector('input[name="policy"]'),
                        answersInput = this.querySelector(`textarea[name="comment"]`),
                        textareaField = this.parentElement.querySelector('textarea') || false,
                        textareaValue = textareaField ? textareaField.value : answersInput ? answersInput.value : false,
                        errorText = this.parentElement.querySelector(`.${errorTextClass}`);
                    policy = policy ? policy.checked : true;

                    // Удаляем текст ошибки
                    if (errorText) {
                        errorText.innerHTML = "";
                    }

                    // Удаляем класс ошибки
                    setTimeout(() => {
                        this.parentElement.querySelector('input[name="tel"]').classList.remove(errorClass);
                    }, 1);
                    setTimeout(() => {
                        this.parentElement.querySelector('input[name="name"]').classList.remove(errorClass);
                    }, 1);
                    setTimeout(() => {
                        errorText.classList.remove('is-active');
                    }, 1);

                    // Формирование данных для отправки
                    let self = this;
                    let data = new FormData();
                    for (let j = 0; j < self.elements.length; j++) {
                        let item = self.elements[j];
                        if (item.name) {
                            if (item.type == 'checkbox') {
                                data.append(item.name, item.checked ? item.value : '');
                            } else {
                                data.append(item.name, item.value);
                            }
                        }
                    }

                    if (this.dataset.time) {
                        data.append('csrf_time', this.dataset.time);
                    }

                    if (this.dataset.token) {
                        data.append('csrf_token', this.dataset.token);
                    }

                    // Ajax
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', options.url);
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState == 4 && xhr.status === 200) {

                            const r = (function() {
                                try {
                                    return JSON.parse(xhr.responseText);
                                } catch (e) {
                                    return {}
                                }
                            })(xhr.responseText);

                            if (r.status == 'ok') {
                                // Снимаем блокировку кнопки
                                feedbackBtn.forEach( function(item) {
                                    item.style.opacity = '';
                                    item.style.cursor = '';
                                    item.disabled = false;
                                });

                                // Функция сработает при удачной отправке формы
                                if (typeof options.statusOk == 'function') {
                                    options.statusOk(self, r);
                                }

                                self.parentElement.querySelector('input[name="name"]').value = '';
                                self.parentElement.querySelector('input[name="tel"]').value = '';
                                if (textareaField) textareaField.value = '';

                            }

                            if (r.status == 'error') {

                                // Снимаем блокировку кнопки
                                feedbackBtn.forEach( function(item) {
                                    item.style.opacity = '';
                                    item.style.cursor = '';
                                    item.disabled = false;
                                });

                                // Выводим текст ошибки
                                if (errorText) {
                                    errorText.innerHTML = r.message;
                                    errorText.classList.add('is-active');
                                }

                                // Добавляем класс ошибки на поля
                                r.fields.forEach( function(item) {
                                    if (item == 'policy') {
                                        self.parentElement.querySelector(`[am-checkbox]`).classList.add(errorClass);
                                    } else {
                                        self.parentElement.querySelector(`input[name="${item}"]`).classList.add(errorClass);
                                    }
                                });

                                // Функция сработает при не удачной отправке формы
                                if (typeof options.statusError == 'function') {
                                    options.statusError(self, r);
                                }

                            }
                        }
                    }

                    xhr.send(data);
                }

                let formCSRF = function() {
                    fetch('/main/get_form_csrf', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    })
                    .then(response => response.json())
                    .then(r => {
                        this.dataset.time  = r.time;
                        this.dataset.token = r.token;
                    });
                }

                // Помечаем инициализированную форму
                formsList[i].classList.add('is-initialized');

                formsList[i].querySelectorAll('.submitButton').forEach(function($item) {
                    $item.addEventListener('click', function() {
                        formSubmitFn.apply(formsList[i]);
                    });
                });

                formsList[i].addEventListener('submit', function(e) {
                    e.preventDefault();
                    formSubmitFn.apply(formsList[i]);
                });

                // делаем csrf запрос
                formsList[i].addEventListener('change', function(e) {
                    e.preventDefault();

                    let has_csrf = !!formsList[i].dataset.has_csrf;
                    if (has_csrf) {
                        return false;
                    }

                    formsList[i].dataset.has_csrf = 1;
                    formCSRF.apply(formsList[i]);
                });

                // Функция сработает после отправки формы
                if (typeof options.afterResponse == 'function') {
                    options.afterResponse(formsList[i]);
                }
            }
        }
    }

    win.Form = Form;
    return Form;

})(window, window.document)
